<template>
  <div>
    <!--    First Version Caspian-->
    <transition
      name="animate__fadeIn"
      enter-active-class="animate__animated animate__fadeIn"
      leave-active-class="animate__animated animate__fadeOut"
      appear
    >
      <b-row
        class="fill-height"
        v-if="getVersion === 'v1' && !getGlobalApiRequestPending"
      >
        <b-col lg="7" class="d-none d-lg-block mt-10">
          <b-container>
            <img src="@/assets/images/background1.png" width="100%" />
          </b-container>
          <b-col cols="12">
            <b-container class="mt-10">
              <h1 class="text-center font-size-xl pb-3">
                {{ $translate("tetherGateway") }}
              </h1>
            </b-container>
          </b-col>
        </b-col>
        <b-col cols="12" lg="5" class="d-flex align-items-center mt-lg-0 mt-5">
          <b-container
            class="background-secondary border-radius-10px border-light-gray-1px midnight-blue-text my-3 min-height-45vh position-relative"
          >
            <b-row class="mt-3">
              <b-col
                cols="4"
                class="d-flex justify-content-center align-items-center"
              >
                <button
                  class="d-flex flex-column background-transparent border-none"
                  @click="handlePageChange('tether-bep20')"
                >
                  <img
                    class="ordinary-img"
                    src="@/assets/images/bep20-tether.png"
                    :class="{
                      'mix-blend-mode-luminosity': !bep20TetherActive,
                    }"
                    height="80"
                    width="80"
                  />
                  <p class="mt-2 mb-0 font-size-medium-small font-weight-bold">
                    {{ $translate("tether") }}-<span class="font-weight-bold">
                      Bep20</span
                    >
                  </p>
                </button>
              </b-col>
              <b-col
                cols="4"
                class="d-flex justify-content-center align-items-center"
              >
                <button
                  class="d-flex flex-column background-transparent border-none"
                  @click="handlePageChange('trc20-tron')"
                >
                  <img
                    class="ordinary-img"
                    src="@/assets/images/tron-icon.png"
                    :class="{
                      'mix-blend-mode-luminosity': !trc20TronActive,
                    }"
                    height="80"
                    width="88"
                  />
                  <p class="mt-2 mb-0 font-size-medium-small font-weight-bold">
                    {{ $translate("tron") }}-<span class="font-weight-bold">
                      TRC20</span
                    >
                  </p>
                </button>
              </b-col>
              <b-col
                cols="4"
                class="d-flex justify-content-center align-items-center"
              >
                <button
                  class="d-flex flex-column background-transparent border-none"
                  @click="handlePageChange('trc20-tether')"
                >
                  <img
                    class="ordinary-img"
                    src="@/assets/images/trc20-tether.png"
                    :class="{
                      'mix-blend-mode-luminosity': !trc20TetherActive,
                    }"
                    height="80"
                    width="80"
                  />
                  <p class="mt-2 mb-0 font-size-medium-small font-weight-bold">
                    {{ $translate("tether") }}-<span class="font-weight-bold">
                      TRC20</span
                    >
                  </p>
                </button>
              </b-col>
            </b-row>
            <b-row
              class="position-absolute fill-width info-text-position d-flex justify-content-center"
            >
              <b-col
                cols="12"
                class="d-flex justify-content-center align-items-center "
              >
                <span
                  class="cornflower-blue-text font-size-large font-weight-bold"
                >
                  {{ $translate("selectYourCurrency") }}
                </span>
              </b-col>
              <b-col
                cols="4"
                class="d-flex justify-content-center align-items-center pt-3"
              >
                <button
                  type="button"
                  class="decline-button"
                  @click="cancelPayment"
                >
                  {{ $translate("cancel") }}
                </button>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </transition>
    <!--    /First Version Caspian-->
  </div>
</template>
<script>
import { cryptoGroupMixin } from "../../mixins/CryptoGroupMixin";

export default {
  name: "CryptoGroup",
  components: {},
  mixins: [cryptoGroupMixin],
};
</script>

<style scoped>
.info-text-position {
  bottom: 10%;
}
.decline-button {
  width: 100%;
  padding: 5px;
  border-radius: 10px;
  border: 1px solid var(--black);
  background-color: transparent;
}
.min-height-45vh {
  min-height: 45vh;
}
</style>
